import { OrderItem as ModuleOrderItem } from '@leid/api-orders'

import { OrderInfo, OrderItemInfo } from 'appTypes/orders'
import { Category } from 'appTypes/shop'

export const SELECTED_PAYMENT_OPTION = 'Klarna'
export const DINTERO_PAYMENT_OPTION = 'dintero'

const events = {
  PRODUCT_REMOVED: 'Product Removed',
  CHECKOUT_STEP_COMPLETED: 'Checkout Step Completed',
  PRODUCT_ADDED: 'Product Added',
  ORDER_COMPLETED: 'Order Completed',
}

const parseCategories = (categories: Category[] | null) => {
  if (!categories) {
    return ''
  }

  return categories.map((category) => category.name).join(', ')
}

export const addToSegmentOnRemoveFromCart = (orderItem: ModuleOrderItem): void => {
  window.analytics.track(events.PRODUCT_REMOVED, {
    product_id: orderItem.id,
    category: parseCategories(null),
    name: orderItem.productData?.name ?? '',
    price: orderItem.price,
    quantity: orderItem.amount,
    url: window.location.href,
  })
}

export const addToSegmentOnCheckout = (step: number, option: string): void => {
  if (step === 1) {
    window.analytics.track(events.CHECKOUT_STEP_COMPLETED, {
      step,
      shipping_method: option,
    })
  } else {
    window.analytics.track(events.CHECKOUT_STEP_COMPLETED, {
      step,
      payment_method: option,
    })
  }
}

export const addToSegmentOnAddToCart = (orderItemInfo: OrderItemInfo): void => {
  window.analytics.track(events.PRODUCT_ADDED, {
    product_id: orderItemInfo.orderItem.id,
    category: parseCategories(null),
    name: orderItemInfo.orderItem.productData?.name ?? '',
    price: orderItemInfo.orderItem.price,
    quantity: orderItemInfo.orderItem.amount,
    url: window.location.href,
  })
}

export const addToSegmentOnDinteroOrderCompleted = (
  order: OrderInfo,
  orderPrice: number | '',
  isProlongation: boolean,
  url: string,
): void => {
  const affiliation = isProlongation ? 'Online Store - Prolongation' : 'Online Store'

  window.analytics.track(events.ORDER_COMPLETED, {
    value: orderPrice ?? 0,
    revenue: orderPrice ?? 0,
    total: orderPrice ?? 0,
    currency: 'NOK',
    order_id: order.order.id,
    transaction_id: order.order.id,
    affiliation,
    products: order.orderItems.map((s) => ({
      product_id: s.orderItem.productId,
      name: s.orderItem.productData?.name ?? '',
      price: s.orderItem.price,
      quantity: s.orderItem.amount,
      location: s.location?.id ?? 0,
      url,
    })),
  })
}

export const addToSegmentOnInvoiceOrderCompleted = (
  order: OrderInfo,
  orderPrice: number | '',
  isProlongation: boolean,
  url: string,
): void => {
  const affiliation = isProlongation ? 'Online Store - Prolongation' : 'Online Store'

  window.analytics.track(events.ORDER_COMPLETED, {
    value: orderPrice ?? 0,
    revenue: orderPrice ?? 0,
    total: orderPrice ?? 0,
    currency: 'NOK',
    order_id: order.order.id,
    transaction_id: order.order.id,
    affiliation,
    products: order.orderItems.map((s) => ({
      product_id: s.orderItem.productId,
      name: s.orderItem.productData?.name ?? '',
      price: s.orderItem.price,
      quantity: s.orderItem.amount,
      location: s.location?.id ?? 0,
      url,
    })),
  })
}
